var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInnerplus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1283,
    height: 213,
    viewBox: "0 0 1283 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M701.636 87H707.363V78.3636H716V72.6369H707.363V64H701.636V72.6369H693V78.3636H701.636V87Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63637 87H14.3631V78.3636H23V72.6369H14.3631V64H8.63637V72.6369H0V78.3636H8.63637V87Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6364 87H77.3631V78.3636H86V72.6369H77.3631V64H71.6364V72.6369H63V78.3636H71.6364V87Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.636 87H140.363V78.3636H149V72.6369H140.363V64H134.636V72.6369H126V78.3636H134.636V87Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M197.636 87H203.363V78.3636H212V72.6369H203.363V64H197.636V72.6369H189V78.3636H197.636V87Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M260.636 87H266.363V78.3636H275V72.6369H266.363V64H260.636V72.6369H252V78.3636H260.636V87Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M323.636 87H329.363V78.3636H338V72.6369H329.363V64H323.636V72.6369H315V78.3636H323.636V87Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M386.636 87H392.363V78.3636H401V72.6369H392.363V64H386.636V72.6369H378V78.3636H386.636V87Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M449.636 87H455.363V78.3636H464V72.6369H455.363V64H449.636V72.6369H441V78.3636H449.636V87Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M512.636 87H518.363V78.3636H527V72.6369H518.363V64H512.636V72.6369H504V78.3636H512.636V87Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M575.636 87H581.363V78.3636H590V72.6369H581.363V64H575.636V72.6369H567V78.3636H575.636V87Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M638.636 87H644.363V78.3636H653V72.6369H644.363V64H638.636V72.6369H630V78.3636H638.636V87Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M764.636 87H770.363V78.3636H779V72.6369H770.363V64H764.636V72.6369H756V78.3636H764.636V87Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M827.636 87H833.363V78.3636H842V72.6369H833.363V64H827.636V72.6369H819V78.3636H827.636V87Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M890.636 87H896.363V78.3636H905V72.6369H896.363V64H890.636V72.6369H882V78.3636H890.636V87Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M953.636 87H959.363V78.3636H968V72.6369H959.363V64H953.636V72.6369H945V78.3636H953.636V87Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.64 87H1022.36V78.3636H1031V72.6369H1022.36V64H1016.64V72.6369H1008V78.3636H1016.64V87Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1079.64 87H1085.36V78.3636H1094V72.6369H1085.36V64H1079.64V72.6369H1071V78.3636H1079.64V87Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1142.64 87H1148.36V78.3636H1157V72.6369H1148.36V64H1142.64V72.6369H1134V78.3636H1142.64V87Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1205.64 87H1211.36V78.3636H1220V72.6369H1211.36V64H1205.64V72.6369H1197V78.3636H1205.64V87Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1268.64 87H1274.36V78.3636H1283V72.6369H1274.36V64H1268.64V72.6369H1260V78.3636H1268.64V87Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63637 23H14.3631V14.3636H23V8.63688H14.3631V0H8.63637V8.63688H0V14.3636H8.63637V23Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6364 23H77.3631V14.3636H86V8.63688H77.3631V0H71.6364V8.63688H63V14.3636H71.6364V23Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M134.636 23H140.363V14.3636H149V8.63688H140.363V0H134.636V8.63688H126V14.3636H134.636V23Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M197.636 23H203.363V14.3636H212V8.63688H203.363V0H197.636V8.63688H189V14.3636H197.636V23Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M260.636 23H266.363V14.3636H275V8.63688H266.363V0H260.636V8.63688H252V14.3636H260.636V23Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M323.636 23H329.363V14.3636H338V8.63688H329.363V0H323.636V8.63688H315V14.3636H323.636V23Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M386.636 23H392.363V14.3636H401V8.63688H392.363V0H386.636V8.63688H378V14.3636H386.636V23Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M449.636 23H455.363V14.3636H464V8.63688H455.363V0H449.636V8.63688H441V14.3636H449.636V23Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M512.636 23H518.363V14.3636H527V8.63688H518.363V0H512.636V8.63688H504V14.3636H512.636V23Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M575.636 23H581.363V14.3636H590V8.63688H581.363V0H575.636V8.63688H567V14.3636H575.636V23Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M638.636 23H644.363V14.3636H653V8.63688H644.363V0H638.636V8.63688H630V14.3636H638.636V23Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M701.636 23H707.363V14.3636H716V8.63688H707.363V0H701.636V8.63688H693V14.3636H701.636V23Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M764.636 23H770.363V14.3636H779V8.63688H770.363V0H764.636V8.63688H756V14.3636H764.636V23Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M827.636 23H833.363V14.3636H842V8.63688H833.363V0H827.636V8.63688H819V14.3636H827.636V23Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M890.636 23H896.363V14.3636H905V8.63688H896.363V0H890.636V8.63688H882V14.3636H890.636V23Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M953.636 23H959.363V14.3636H968V8.63688H959.363V0H953.636V8.63688H945V14.3636H953.636V23Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.64 23H1022.36V14.3636H1031V8.63688H1022.36V0H1016.64V8.63688H1008V14.3636H1016.64V23Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1079.64 23H1085.36V14.3636H1094V8.63688H1085.36V0H1079.64V8.63688H1071V14.3636H1079.64V23Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1142.64 23H1148.36V14.3636H1157V8.63688H1148.36V0H1142.64V8.63688H1134V14.3636H1142.64V23Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1205.64 23H1211.36V14.3636H1220V8.63688H1211.36V0H1205.64V8.63688H1197V14.3636H1205.64V23Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1268.64 23H1274.36V14.3636H1283V8.63688H1274.36V0H1268.64V8.63688H1260V14.3636H1268.64V23Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63637 150H14.3631V141.364H23V135.637H14.3631V127H8.63637V135.637H0V141.364H8.63637V150Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6364 150H77.3631V141.364H86V135.637H77.3631V127H71.6364V135.637H63V141.364H71.6364V150Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M134.636 150H140.363V141.364H149V135.637H140.363V127H134.636V135.637H126V141.364H134.636V150Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M197.636 150H203.363V141.364H212V135.637H203.363V127H197.636V135.637H189V141.364H197.636V150Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M260.636 150H266.363V141.364H275V135.637H266.363V127H260.636V135.637H252V141.364H260.636V150Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M323.636 150H329.363V141.364H338V135.637H329.363V127H323.636V135.637H315V141.364H323.636V150Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M386.636 150H392.363V141.364H401V135.637H392.363V127H386.636V135.637H378V141.364H386.636V150Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M449.636 150H455.363V141.364H464V135.637H455.363V127H449.636V135.637H441V141.364H449.636V150Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M512.636 150H518.363V141.364H527V135.637H518.363V127H512.636V135.637H504V141.364H512.636V150Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M575.636 150H581.363V141.364H590V135.637H581.363V127H575.636V135.637H567V141.364H575.636V150Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M638.636 150H644.363V141.364H653V135.637H644.363V127H638.636V135.637H630V141.364H638.636V150Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M701.636 150H707.363V141.364H716V135.637H707.363V127H701.636V135.637H693V141.364H701.636V150Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M764.636 150H770.363V141.364H779V135.637H770.363V127H764.636V135.637H756V141.364H764.636V150Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M827.636 150H833.363V141.364H842V135.637H833.363V127H827.636V135.637H819V141.364H827.636V150Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M890.636 150H896.363V141.364H905V135.637H896.363V127H890.636V135.637H882V141.364H890.636V150Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M953.636 150H959.363V141.364H968V135.637H959.363V127H953.636V135.637H945V141.364H953.636V150Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.64 150H1022.36V141.364H1031V135.637H1022.36V127H1016.64V135.637H1008V141.364H1016.64V150Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1079.64 150H1085.36V141.364H1094V135.637H1085.36V127H1079.64V135.637H1071V141.364H1079.64V150Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1142.64 150H1148.36V141.364H1157V135.637H1148.36V127H1142.64V135.637H1134V141.364H1142.64V150Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1205.64 150H1211.36V141.364H1220V135.637H1211.36V127H1205.64V135.637H1197V141.364H1205.64V150Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1268.64 150H1274.36V141.364H1283V135.637H1274.36V127H1268.64V135.637H1260V141.364H1268.64V150Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63637 213H14.3631V204.364H23V198.637H14.3631V190H8.63637V198.637H0V204.364H8.63637V213Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6364 213H77.3631V204.364H86V198.637H77.3631V190H71.6364V198.637H63V204.364H71.6364V213Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M134.636 213H140.363V204.364H149V198.637H140.363V190H134.636V198.637H126V204.364H134.636V213Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M197.636 213H203.363V204.364H212V198.637H203.363V190H197.636V198.637H189V204.364H197.636V213Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M260.636 213H266.363V204.364H275V198.637H266.363V190H260.636V198.637H252V204.364H260.636V213Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M323.636 213H329.363V204.364H338V198.637H329.363V190H323.636V198.637H315V204.364H323.636V213Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M386.636 213H392.363V204.364H401V198.637H392.363V190H386.636V198.637H378V204.364H386.636V213Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M449.636 213H455.363V204.364H464V198.637H455.363V190H449.636V198.637H441V204.364H449.636V213Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M512.636 213H518.363V204.364H527V198.637H518.363V190H512.636V198.637H504V204.364H512.636V213Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M575.636 213H581.363V204.364H590V198.637H581.363V190H575.636V198.637H567V204.364H575.636V213Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M638.636 213H644.363V204.364H653V198.637H644.363V190H638.636V198.637H630V204.364H638.636V213Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M701.636 213H707.363V204.364H716V198.637H707.363V190H701.636V198.637H693V204.364H701.636V213Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M764.636 213H770.363V204.364H779V198.637H770.363V190H764.636V198.637H756V204.364H764.636V213Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M827.636 213H833.363V204.364H842V198.637H833.363V190H827.636V198.637H819V204.364H827.636V213Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M890.636 213H896.363V204.364H905V198.637H896.363V190H890.636V198.637H882V204.364H890.636V213Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M953.636 213H959.363V204.364H968V198.637H959.363V190H953.636V198.637H945V204.364H953.636V213Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.64 213H1022.36V204.364H1031V198.637H1022.36V190H1016.64V198.637H1008V204.364H1016.64V213Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M1079.64 213H1085.36V204.364H1094V198.637H1085.36V190H1079.64V198.637H1071V204.364H1079.64V213Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M1142.64 213H1148.36V204.364H1157V198.637H1148.36V190H1142.64V198.637H1134V204.364H1142.64V213Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1205.64 213H1211.36V204.364H1220V198.637H1211.36V190H1205.64V198.637H1197V204.364H1205.64V213Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M1268.64 213H1274.36V204.364H1283V198.637H1274.36V190H1268.64V198.637H1260V204.364H1268.64V213Z",
    fill: "#FFB374",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnerplus);
export default __webpack_public_path__ + "static/media/innerplus.8e399d387b1f1bdde9986e2d40b8abd2.svg";
export { ForwardRef as ReactComponent };